/* Carter · Film — riproduzione automatica.

   Il file resta in data-src e viene agganciato quando serve: così la pagina
   non scarica il video prima del tempo. Poi load() + play() forzano l'avvio.
   Parte muto (i browser non ammettono altro), va in loop, e il tasto in
   basso a destra accende l'audio.

   Ci sono tre inneschi, perché su alcuni temi lo scroll avviene dentro un
   contenitore e l'osservatore da solo non basta:
   1) la sezione si avvicina allo schermo
   2) il primo scroll o tocco sulla pagina
   3) un timer di sicurezza dopo 2,5 secondi
*/
(function(){

  function hydrate(v){
    if (v.dataset.ready) return;
    var s = v.querySelector('source[data-src]');
    if (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); }
    v.dataset.ready = '1';
    v.load();
  }

  function start(p){
    if (p.dataset.carterFilm) return;
    p.dataset.carterFilm = '1';

    var v = p.querySelector('video');
    if (!v) return;

    var manual = p.querySelector('.play');
    if (manual) {                    /* modalità con pulsante play */
      manual.addEventListener('click', function(){ p.classList.add('playing'); hydrate(v); v.play(); });
      v.addEventListener('ended', function(){ p.classList.remove('playing'); v.currentTime = 0; });
      return;
    }

    v.muted = true; v.setAttribute('muted',''); v.playsInline = true; v.loop = true;

    function go(){
      hydrate(v);
      var r = v.play();
      if (r && r.catch) r.catch(function(){});
    }

    /* 1 — quando la sezione si avvicina */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting) { go(); io.disconnect(); } });
      }, { rootMargin: '800px 0px' });
      io.observe(p);
    }

    /* 2 — primo scroll o tocco */
    ['scroll','wheel','touchstart','click','keydown'].forEach(function(ev){
      var h = function(){ go(); ['scroll','wheel','touchstart','click','keydown'].forEach(function(e2){
        window.removeEventListener(e2, h, true);
      }); };
      window.addEventListener(ev, h, { passive:true, capture:true });
    });

    /* 3 — rete di sicurezza */
    setTimeout(go, 2500);

    document.addEventListener('visibilitychange', function(){
      if (document.hidden) v.pause(); else if (v.dataset.ready) go();
    });

    var sound = p.querySelector('.sound');
    if (sound) {
      sound.addEventListener('click', function(ev){
        ev.stopPropagation();
        v.muted = !v.muted;
        p.classList.toggle('audio-on', !v.muted);
        go();
      });
    }
  }

  function init(){ document.querySelectorAll('.carter-film .player').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
